import CardComponent from './CardComponent';

const Participate = () => {
    return (
        <CardComponent pageTitle='participate' />
    )
}

export default Participate;